export default {"src":"/_next/static/media/txt.f2409f6a.svg","height":512,"width":513};